/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  events: 'change|blur'
});

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

// File upload
const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

// Responsive css style
import '@/assets/css/responsive.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

if (localStorage.getItem('authToken')) {
  store.dispatch('updateAuthToken', localStorage.getItem('authToken'))
}
if (localStorage.getItem('user')) {
  store.dispatch('updateUser', JSON.parse(localStorage.getItem('user')))
}

// i18n
import i18n from './i18n/i18n'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

//use axios
import './axios'

//Mixin
import "./mixins/mixin";

// Vue select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css';

//  Moment
// Vue.use(require('vue-moment'));

// Google Icons
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput);

Vue.use(VueMaterial);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
